import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";

/**
 * @class Currency
 * @property {number} id
 * @property {string} name
 * @property {string} status
 */
export class Currency extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    static get validationModel() {

        return {
            name: {
                label: 'CURRENCY_NAME_IN_ENGLISH',
                commonLabel: 'Currency name'
            },
            name_ar: {
                label: 'CURRENCY_NAME_IN_ARABIC',
                commonLabel: 'Currency name'
            },
        };
    }
}

AccessorsMutatorsDecorator('id', ...Currency.translatableAttributesWithLanguageAliases, 'status', 'general_settings', 'is_default', 'code')(Currency);


// WEBPACK FOOTER //
// ./src/pms-api/models/currency.model.js